import { POLLING_NOTIFICATIONS_MS } from "../config";
import { hrStore } from "./HrStore";

// Central place for managing all polling calls
export class PollingManager {
    notificationTimer?: NodeJS.Timeout = undefined;

    pollNotification = async () => {
        if (this.notificationTimer) {
            clearInterval(this.notificationTimer);
        }

        await hrStore.loadNotifications();
        this.notificationTimer = setInterval(hrStore.loadNotifications, POLLING_NOTIFICATIONS_MS);
    };

    stopPolling = () => {
        if (this.notificationTimer) {
            clearInterval(this.notificationTimer);
        }
    };
}

export const pollingManager = new PollingManager();
